export type UiNode = {
  attributes?: { name?: string; type?: string; value?: any };
  messages?: Array<{ text: string }>;
};

export function getNodeValue(
  nodes: UiNode[] | undefined,
  name: string,
): string | null {
  const n = nodes?.find((n) => n.attributes?.name === name);
  return (n?.attributes?.value ?? null) as string | null;
}

export function hasNode(nodes: UiNode[] | undefined, name: string): boolean {
  return !!nodes?.some((n) => n.attributes?.name === name);
}
